import {useQuery} from 'react-query'

import {getAppearanceTemplateByIdQuery} from '../display-settings/get-appearance-template'
import {AppearanceTemplateElement} from '../display-settings/types'
import {useVenue} from '../venue/hooks'

export const getEntityDataByIdFromAppearanceSettings: (
  venueId: string,
  id: string,
) => AppearanceTemplateElement['data'] | null = (venueId, id) => {
  const {data: venueData} = useVenue()
  const {data: settings} = useQuery(getAppearanceTemplateByIdQuery({params: {id: venueData?.appearanceTemplateId}}))
  let entityToReturn: AppearanceTemplateElement['data']
  if (settings) {
    (settings as AppearanceTemplateElement[]).forEach((el) => {
      if (el.data && el.entityId === id) {
        entityToReturn = el.data
        return
      }
      if (el.items) {
        (el.items as AppearanceTemplateElement[]).forEach((item) => {
          if (item.data && item.entityId === id) {
            entityToReturn = item.data
            return
          }
        })
      }
    })
  }
  return entityToReturn || null
}

// Has the venue's appearance template settled? The three booking-form wrappers look their entity up
// in it; on a direct deep link or a cross-venue link it is still loading on the first render, so they
// used to compute from null, throw, and the route's error boundary sent the visitor to the venue root.
export const useAppearanceEntityLookup = (venueId?: string) => {
  const {data: venueData, isError: venueError} = useVenue()
  const templateId = venueData?.uid === venueId ? venueData?.appearanceTemplateId : undefined
  const {data: settings, isSuccess, isError} = useQuery(
    getAppearanceTemplateByIdQuery({params: {id: templateId}, enabled: Boolean(templateId)}),
  )
  const isReady = templateId ? isSuccess || isError : venueError
  const find = (id?: string | null): AppearanceTemplateElement['data'] | null => {
    if (!id || !settings) {
 return null
}
    for (const el of settings as AppearanceTemplateElement[]) {
      if (el.data && el.entityId === id) {
 return el.data
}
      for (const item of (el.items || []) as AppearanceTemplateElement[]) {
        if (item.data && item.entityId === id) {
 return item.data
}
      }
    }
    return null
  }
  return {isReady, find}
}
